export const environment = {
  ENV: 'dit',
  APP: 'asm-prototype',
  KEYCLOAK_REALM: 'asm',
  KEYCLOAK_URL: 'https://asm-auth.ditext.outpost24.com/auth',
  KEYCLOAK_CLIENT_ID: 'asm-prototype',
  LEGACY_ASM_PLATFORM_URL: 'https://asm-platform.ditext.outpost24.com',
};
